import { IProductDetails } from '@models/IProductDetails';
import axios from 'axios';
import qs from 'qs';

interface Params {
  readonly getProductDetailsByMaterialCodeEndpoint: string;
  readonly language: string;
  readonly materialCode: string;
}

const getProductDetails = async ({
  getProductDetailsByMaterialCodeEndpoint,
  language,
  materialCode,
}: Params): Promise<IProductDetails> => {
  const query = qs.stringify({
    language,
    materialCode,
  });

  const { data } = await axios.get<IProductDetails>(
    `${getProductDetailsByMaterialCodeEndpoint}?${query}`
  );

  return data;
};

export default getProductDetails;
